export const COMMON_API = "https://api.mahaarth.com/api";
// export const COMMON_API = "http://localhost:8000/api";